// StockistSMS.jsx
import React, { useEffect, useState } from "react";
import {
  fetchStockistData,
  fetchMessageStatus,
  sendStockistMessage,
} from "../services/stockistService";
import { BASE_URL } from "../config";
import { getAuthHeaders } from "../services/useAuth";
import * as XLSX from "xlsx";
import CustomButton from "./CustomButton";
const StockistSMS = () => {
  // State variables (unchanged from your original)
  const [states, setStates] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [showTable, setShowTable] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [daysInMonth, setDaysInMonth] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [messageStatus, setMessageStatus] = useState({});
  const [selectedCell, setSelectedCell] = useState(null);
const tableRef = React.useRef(null);
  // month helpers (unchanged)
  const getMonthOptions = () => {
    const months = [];
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();

    for (let month = 0; month < 12; month++) {
      const monthName = new Date(currentYear, month, 1).toLocaleString(
        "default",
        { month: "long" }
      );
      months.push({
        value: `${currentYear}-${(month + 1).toString().padStart(2, "0")}`,
        label: `${monthName} ${currentYear}`,
      });
    }
    return months;
  };

  const monthOptions = getMonthOptions();

  useEffect(() => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = (currentDate.getMonth() + 1)
      .toString()
      .padStart(2, "0");
    setSelectedMonth(`${currentYear}-${currentMonth}`);
  }, []);

  useEffect(() => {
    if (selectedMonth) {
      const [year, month] = selectedMonth.split("-").map(Number);
      const daysInMonth = new Date(year, month, 0).getDate();
      const days = Array.from({ length: daysInMonth }, (_, i) => i + 1);
      setDaysInMonth(days);
    }
  }, [selectedMonth]);

  // fetch states/divisions/employees (unchanged)
  useEffect(() => {
    fetch(`${BASE_URL}/api/states`, {
      headers: getAuthHeaders(),
    })
      .then((res) => res.json())
      .then((data) => setStates(data))
      .catch((err) => console.error(err));

    fetch(`${BASE_URL}/api/divisions`, {
      headers: getAuthHeaders(),
    })
      .then((res) => res.json())
      .then((data) => setDivisions(data))
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    if (selectedState) {
      let url = `${BASE_URL}/api/employees?state_id=${selectedState}`;
      if (selectedDivision) {
        url += `&division=${selectedDivision}`;
      }

      fetch(url, {
        headers: getAuthHeaders(),
      })
        .then((res) => res.json())
        .then((data) => setEmployees(data))
        .catch((err) => console.error(err));
    } else {
      setEmployees([]);
    }
  }, [selectedState, selectedDivision]);

  // handleGo, formatDateTime, handleDayClick, handleSendMessage, renderStatusCell,
  // handlePrint, handleExportToExcel — all unchanged logic, only minor internal formatting left intact

  const handleGo = async () => {
    if (!selectedEmployee || !selectedMonth) return;

    try {
      const response = await fetch(
        `${BASE_URL}/api/stockist/sms-data?employee_id=${selectedEmployee}&month=${selectedMonth}`,
        {
          headers: getAuthHeaders(),
        }
      );
      const data = await response.json();

      const tableData = data.map((item) => ({
        employee_id: item.employee_id,
        employee_name: item.employee_name,
        designation: item.designation,
        hq_name: item.hq_name || "--",
        stockist_id: item.stockist_id,
        stockist_code: item.stockist_code || "--",
        stockist_name: item.stockist_name || "--",
        city: item.city || "--",
        mobile: item.mobile || "--",
        message_map: item.message_map || {},
      }));

      setTableData(tableData);
      setShowTable(true);
    } catch (err) {
      console.error(err);
      setTableData([]);
      alert("Failed to fetch data");
    }
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date
      .toLocaleString("en-US", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
        timeZone: "Asia/Kolkata",
      })
      .replace(",", "")
      .replace("GMT+0530 (India Standard Time)", "")
      .trim();
  };

  const handleDayClick = (item, day) => {
    const date = `${selectedMonth}-${day.toString().padStart(2, "0")}`;
    const statusKey = `${item.stockist_id}-${date}`;
    const messageData = item.message_map ? item.message_map[statusKey] : null;

    setSelectedCell({
      item,
      day,
      date,
      messageData: messageData || null,
    });
    setShowPopup(true);
  };

  const handleSendMessage = async () => {
    if (!selectedCell) return;

    try {
      const now = new Date();
      const formattedDate = formatDateTime(now);

      const messageData = {
        employee_id: selectedCell.item.employee_id,
        stockist_id: selectedCell.item.stockist_id,
        pob: selectedCell.item.pob || 0,
        message_date: selectedCell.date,
        message: `Dear ${selectedCell.item.stockist_name}, ${
          selectedCell.item.employee_name
        } (${selectedCell.item.designation}) has booked POB ${
          selectedCell.item.pob?.toFixed(2) || "0.00"
        } for ${formattedDate}. Kindly acknowledge.`,
        sent_at: now.toISOString(),
      };

      const response = await sendStockistMessage(messageData);

      const statusKey = `${selectedCell.item.stockist_id}-${selectedCell.date}`;
      setTableData((prev) =>
        prev.map((item) => {
          if (item.stockist_id === selectedCell.item.stockist_id) {
            return {
              ...item,
              message_map: {
                ...item.message_map,
                [statusKey]: {
                  status: "sent",
                  pob: selectedCell.item.pob || 0,
                  sent_at: now.toISOString(),
                  message: messageData.message,
                },
              },
            };
          }
          return item;
        })
      );

      alert("Message sent successfully!");
      setShowPopup(false);
    } catch (err) {
      console.error(err);
      alert("Failed to send message");
    }
  };

  const renderStatusCell = (stockistId, day) => {
    const date = `${selectedMonth}-${day.toString().padStart(2, "0")}`;
    const statusKey = `${stockistId}-${date}`;
    const item = tableData.find((item) => item.stockist_id === stockistId);
    return item?.message_map?.[statusKey]?.status === "sent" ? "Yes" : "No";
  };

  const handlePrint = () => {
    const printWindow = window.open("", "_blank");
    printWindow.document.write(
      "<html><head><title>Print Table</title></head><body>"
    );
    printWindow.document.write("<h1>SMS Posted Details</h1>");
    const tableHtml =
      document.querySelector(".stockist-sms-table")?.outerHTML ||
      "<p>No table</p>";
    printWindow.document.write(tableHtml);
    printWindow.document.write("</body></html>");
    printWindow.document.close();
    printWindow.print();
  };

  const handleExportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(tableData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Stockist Data");
    XLSX.writeFile(wb, "Stockist_SMS_Data.xlsx");
  };

  // -------------------------
  // Presentational JSX only
  // -------------------------
  return (
    <div className="w-full p-4 box-border min-h-screen flex flex-col bg-gray-50">
      {/* FILTER CARD: large bordered rounded container like screenshot */}
      <div className="w-full border-2 border-gray-300 rounded-lg bg-white p-6 mb-6">
        {/* Title centered inside the bordered card */}
        <div className="flex items-center justify-center pr-6">
          <h2 className="text-2xl font-bold text-gray-800 mb-2">
            <span className="text-blue-700">Message </span>
            <span className="text-blue-500">Stockist</span>
          </h2>
        </div>

        <div className="flex items-center justify-center">
          {/* Form area centered in the card */}
          <div className="w-2/3">
            <form className="w-full">
              <div className="grid grid-cols-2 gap-x-6 gap-y-4 justify-center mx-auto">
                {/* left column pair */}
                <div className="flex items-center justify-start">
                  <label className="w-28 text-right pr-3 text-sm font-medium text-gray-700">
                    State
                  </label>
                  <select
                    className="flex-1 px-3 py-2 border border-gray-300 rounded-md"
                    value={selectedState}
                    onChange={(e) => setSelectedState(e.target.value)}
                  >
                    <option value="">Select State</option>
                    {states.map((state) => (
                      <option key={state.id} value={state.id}>
                        {state.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* right column pair */}
                <div className="flex items-center justify-start">
                  <label className="w-28 text-right pr-3 text-sm font-medium text-gray-700">
                    Division
                  </label>
                  <select
                    className="flex-1 px-3 py-2 border border-gray-300 rounded-md"
                    value={selectedDivision}
                    onChange={(e) => setSelectedDivision(e.target.value)}
                  >
                    <option value="">Select Division</option>
                    {divisions.map((d) => (
                      <option key={d.id} value={d.name}>
                        {d.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="flex items-center justify-start">
                  <label className="w-28 text-right pr-3 text-sm font-medium text-gray-700">
                    Employee
                  </label>
                  <select
                    className="flex-1 px-3 py-2 border border-gray-300 rounded-md"
                    value={selectedEmployee}
                    onChange={(e) => setSelectedEmployee(e.target.value)}
                  >
                    <option value="">Select Employee</option>
                    {employees.map((emp) => (
                      <option key={emp.id} value={emp.id}>
                        {emp.first_name} {emp.last_name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="flex items-center justify-start">
                  <label className="w-28 text-right pr-3 text-sm font-medium text-gray-700">
                    Month
                  </label>
                  <select
                    className="flex-1 px-3 py-2 border border-gray-300 rounded-md"
                    value={selectedMonth}
                    onChange={(e) => setSelectedMonth(e.target.value)}
                  >
                    {monthOptions.map((m) => (
                      <option key={m.value} value={m.value}>
                        {m.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Go button centered below form (like screenshot) */}
              <div className="mt-6 flex justify-center ml-20">
               <CustomButton
                  type="button"
                  variant="go"
                  label={"Go"}
                  onClick={handleGo}
               />
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* TABLE CARD: blue headers, bordered rounded */}
      {showTable && (
        <div className="w-full border-2 border-gray-300 rounded-lg bg-white p-4 mb-8">
          <div className="flex items-center justify-center mb-3">
            <h3 className="text-lg font-semibold text-gray-800">
              SMS Posted -{" "}
              {new Date(`${selectedMonth}-01`).toLocaleString("default", {
                month: "long",
                year: "numeric",
              })}
            </h3>
          </div>

          {/* Scroll wrapper: THIS must be the element with overflow for sticky to work */}
        <div className="border rounded shadow  table-wrapper">
        <table className="unlock-dcr-leave-table text-sm " ref={tableRef}>
          <thead className="bg-blue-500 text-white">
                <tr className="">
                  <th className="sticky top-0 z-20 bg-blue-600 text-white px-3 py-2 border text-left text-sm font-semibold whitespace-nowrap">
                    S.No
                  </th>
                  <th className="sticky top-0 z-20 bg-blue-600 text-white px-3 py-2 border text-left text-sm font-semibold whitespace-nowrap">
                    Employee ID
                  </th>
                  <th className="sticky top-0 z-20 bg-blue-600 text-white px-3 py-2 border text-left text-sm font-semibold whitespace-nowrap">
                    Name
                  </th>
                  <th className="sticky top-0 z-20 bg-blue-600 text-white px-3 py-2 border text-left text-sm font-semibold whitespace-nowrap">
                    Headquarter
                  </th>
                  <th className="sticky top-0 z-20 bg-blue-600 text-white px-3 py-2 border text-left text-sm font-semibold whitespace-nowrap">
                    Designation
                  </th>
                  <th className="sticky top-0 z-20 bg-blue-600 text-white px-3 py-2 border text-left text-sm font-semibold whitespace-nowrap">
                    Stockist Code
                  </th>
                  <th className="sticky top-0 z-20 bg-blue-600 text-white px-3 py-2 border text-left text-sm font-semibold whitespace-nowrap">
                    Stockist Name
                  </th>
                  <th className="sticky top-0 z-20 bg-blue-600 text-white px-3 py-2 border text-left text-sm font-semibold whitespace-nowrap">
                    City
                  </th>
                  <th className="sticky top-0 z-20 bg-blue-600 text-white px-3 py-2 border text-left text-sm font-semibold whitespace-nowrap">
                    Mobile
                  </th>

                  {daysInMonth.map((day) => (
                    <th
                      key={day}
                      className="sticky top-0 z-20 bg-blue-600 text-white px-2 py-2 border text-center text-sm font-medium whitespace-nowrap"
                    >
                      {day}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {tableData.map((item, index) => (
                  <tr
                    key={index}
                    className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
                  >
                    <td className="px-3 py-2 border text-sm whitespace-nowrap">
                      {index + 1}
                    </td>
                    <td className="px-3 py-2 border text-sm whitespace-nowrap">
                      {item.employee_id}
                    </td>
                    <td className="px-3 py-2 border text-sm">
                      {item.employee_name}
                    </td>
                    <td className="px-3 py-2 border text-sm whitespace-nowrap">
                      {item.hq_name || "--"}
                    </td>
                    <td className="px-3 py-2 border text-sm whitespace-nowrap">
                      {item.designation}
                    </td>
                    <td className="px-3 py-2 border text-sm whitespace-nowrap">
                      {item.stockist_code || "--"}
                    </td>
                    <td className="px-3 py-2 border text-sm">
                      {item.stockist_name || "--"}
                    </td>
                    <td className="px-3 py-2 border text-sm whitespace-nowrap">
                      {item.city || "--"}
                    </td>
                    <td className="px-3 py-2 border text-sm whitespace-nowrap">
                      {item.mobile || "--"}
                    </td>

                    {daysInMonth.map((day) => (
                      <td
                        key={day}
                        className="px-2 py-2 border text-center text-sm text-blue-700 hover:bg-gray-100 cursor-pointer whitespace-nowrap"
                        onClick={() => handleDayClick(item, day)}
                      >
                        {renderStatusCell(item.stockist_id, day)}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
         <div className="mt-4 flex gap-4 justify-center">
              <CustomButton onClick={handlePrint} label="Print" variant="print">
                🖨
              </CustomButton>
              <CustomButton
                onClick={handleExportToExcel}
                label="Export"
                variant="export"
              >
                📥
              </CustomButton>
            </div>
        </div>
      )}

      {/* Popup (unchanged visuals but with Tailwind) */}
      {showPopup && selectedCell && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-lg p-6">
            <div className="text-center mb-4">
              <h3 className="text-lg font-semibold">Message Log Details</h3>
            </div>

            <div className="space-y-3 text-sm">
              {selectedCell.messageData ? (
                <>
                  <p>
                    <strong>Message:</strong>
                    <br />
                    {selectedCell.messageData.message}
                  </p>
                  <p>
                    <strong>Sent At:</strong>{" "}
                    {formatDateTime(selectedCell.messageData.sent_at)}
                  </p>
                  <p>
                    <strong>POB Value:</strong>{" "}
                    {selectedCell.messageData.pob?.toFixed(2) || "0.00"}
                  </p>
                </>
              ) : (
                <>
                  <p>
                    <strong>New Message:</strong>
                    <br />
                    {`Dear ${selectedCell.item.stockist_name}, ${
                      selectedCell.item.employee_name
                    } (${selectedCell.item.designation}) has booked POB ${
                      selectedCell.item.pob?.toFixed(2) || "0.00"
                    } . Kindly acknowledge.`}
                  </p>
                  <p>
                    <strong>Sent At:</strong> {formatDateTime(new Date())}
                  </p>
                </>
              )}
            </div>

            <div className="mt-6 flex justify-center gap-4">
              {!selectedCell.messageData && (
                <button
                  onClick={handleSendMessage}
                  className="bg-green-600 hover:bg-green-700 text-white rounded-md px-5 py-2"
                >
                  Send
                </button>
              )}
              <button
                onClick={() => setShowPopup(false)}
                className="bg-red-600 hover:bg-red-700 text-white rounded-md px-5 py-2"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StockistSMS;
